export default (key) => {
  // Handle special cases first
  if (key === "Other (invalid, uncategorised)") {
    return "oth";
  }
  
  // Check if the key contains brackets - if so, use bracket content instead of action
  const bracketMatch = key.match(/\(([^)]+)\)/);
  
  // Split by whitespace and clean up parts
  const parts = key.split(/\s+/).map(part => part.trim()).filter(part => part.length > 0);
  
  // Define abbreviation mappings for common terms
  const abbreviations = {
    // Categories
    'absent': 'abs',
    'accents': 'acc',
    'articulation': 'art',
    'duration': 'dur',
    'dynamics': 'dyn',
    'expression': 'exp',
    'extra': 'ext',
    'fermata': 'fer',
    'grace': 'grc',
    'hand': 'hnd',
    'signs': 'sgn',
    'ornaments': 'orn',
    'other': 'oth',
    'pitch': 'pit',
    'rests': 'rst',
    'slurs': 'slr',
    'and': '',
    'ties': 'tie',
    'stems': 'stm',
    'tuplet': 'tup',
    
    // Actions and modifiers
    'added': 'add',
    'removal': 'rem',
    'changed': 'chg',
    'change': 'chg',
    'changes': 'chg',
    'accidental': 'acc',
    'note': 'not',
    'notes': 'not',
    'bars': 'bar',
    'indications': 'ind',
    'to': '',
    'or': '',
    'removed': 'rem'
  };
  
  // Function to abbreviate a single part
  function abbreviatePart(part) {
    const cleaned = part.toLowerCase().replace(/[():]/g, '').trim();
    
    // Skip empty parts or connecting words
    if (!cleaned || abbreviations[cleaned] === '') {
      return '';
    }
    
    // Check direct mapping first
    if (abbreviations[cleaned]) {
      return abbreviations[cleaned];
    }
    
    // If no mapping found, use first 3 characters
    return cleaned.substring(0, 3);
  }
  
  // If there are brackets, just get the main category and bracket content
  if (bracketMatch) {
    const mainWord = parts[0];
    const mainAbbrev = abbreviatePart(mainWord);
    return `${mainAbbrev} (${bracketMatch[1]})`;
  }
  
  // Otherwise, process all words
  const abbreviatedParts = parts
    .map(part => abbreviatePart(part))
    .filter(abbrev => abbrev.length > 0);
  
  return abbreviatedParts.join(' ');
}